import React, { useState, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import { ServiceApi } from "../../services/index.service";
import { useSnackbar } from "notistack";
import ImageUploader from "../../utils/MultipleImageUploader";

import {
  Autocomplete,
  Backdrop,
  Button,
  CircularProgress,
  DialogActions,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

const names = [
  'Red',
  'Black',
  'Yellow',
  'Blue',
  'Orange',
];

export const ProductDetails = ({ 
  openDialog, 
  handleConfirmDialog, 
  imageData, 
  categoriesList, 
  action, 
  productDetails, 
  callBackFunctions,
  refreshData
}) => {
    
  const { enqueueSnackbar } = useSnackbar();
  const serviceapi = new ServiceApi();
  let productCategory = categoriesList.find(item => item.id === productDetails?.category_id) || '';
  const [currentProduct, setCurrentProduct] = useState(productDetails);
  const [payloadForProductEdit, setPayload] = useState({'httpMethod' : "PATCH", 'payload' : {}})
  const [category, setCategory] = useState(productCategory?.name);
  let colors = [];
  let type = "";
  let initalImages = [];
  if(action === "edit") {
    let temp = JSON.parse(productDetails?.attributes)?.color
    if ( temp ) colors = Array.isArray(temp) ? temp : [temp];
    type = JSON.parse(productDetails?.attributes)?.size;
    if ( productDetails?.images !== "NA") {
      initalImages = JSON.parse(productDetails?.images);
    }
  }
  const [availableColor, setAvailableColor] = useState(colors);
  const [availableType, setAvailableType] = useState(type);
  
  const [isInStock, setIsInStock] = useState(productDetails?.status);
  const [loading, setLoading] = useState(false);
  const [modified,setModified]=useState(false)
  
  // Image 
  const [images, setImages] = useState(initalImages);
  let updateButtonDisabled = images.length === 0;

  const handleClose = () => {
    handleConfirmDialog();
  };

  const getPurchaseMerchendiseCreateProduct = async () => {
    const requestBody = {
      category_id: currentProduct?.category_id,
      name: currentProduct?.name,
      description: currentProduct?.description,
      price: currentProduct?.price,
      stock: 5, // need to confirm with surya
      images: images,
      attributes: {
        color: availableColor,
        size: availableType
      },
      status: isInStock,
    };
    setLoading(true);
    const response = await serviceapi?.purchaseMerchendiseCreateProduct(requestBody);
    setLoading(false);

    const { statusCode, body } = response;
    let message = ""
    try {
      const information = JSON.parse(body)
      message = information?.message;
    } catch(error) {
      console.error(error);
      message = "Something Went Wrong"
    }
    enqueueSnackbar(message , {
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
      variant: statusCode === 200 ? "success" : "error",
    });
    if (statusCode === 200) {
      handleConfirmDialog();
      refreshData();
    }
  };

  const handlePriceChange =(value) => {
    value = value.replace(/[^0-9.]+/g, ''); // Remove non-numeric characters
    const parts = value.split('.');
    if (parts.length === 2) {
      // More than one decimal point, keep only the first two parts
      value = parts[0] + "." + parts[1].slice(0,2)
    }
    value=parseFloat(value  )
    // Now value contains only numeric characters and at most two decimal places
    setCurrentProduct({ ...currentProduct, price: value });
    setPayload(
      {...payloadForProductEdit,
           payload:
           {  ...payloadForProductEdit.payload,
               price : value
          }
      })
  }

  const handleChange =(val, item) => {
    let value=val
    if (item === "type") {
        setAvailableType(value);
        let attributes = JSON.parse(currentProduct.attributes);
        //Other Component are using 'size' attribute, this needs to be changed to 'type' in future.
        attributes.size = value;
        value = JSON.stringify(attributes);
        item = "attributes"
    }

    if (item === "color") {
      value=[ ...value.slice(-1) ];
      setAvailableColor(value);
      let attributes = JSON.parse(currentProduct.attributes);
      //Other Component are using 'size' attribute, this needs to be changed to 'type' in future.
      attributes.color = value;
      value = JSON.stringify(attributes);
      item = "attributes"
  }

    if (item === "category" ) { 
      setCategory(value);
      //Get ID from Name of the category
      value = categoriesList.find(item => item.name === value).id;
      item += '_id';
      setAvailableType('');
    }

    if(item === "inStock") {
      setIsInStock(value);
      item = "status"
      value = value;
    }

    setCurrentProduct({...currentProduct, [item] : value});
    setPayload(
        {...payloadForProductEdit,
             payload:
             {  ...payloadForProductEdit.payload,
                 [item] : value
            }
        })
  }

  const handleValdiation=()=>{
    if(!availableType || availableColor?.length===0 || !currentProduct?.price || currentProduct?.price <= 0 || !currentProduct?.description || !currentProduct?.name || !currentProduct?.category_id ||images?.length === 0 ){
      return false
    }
    return true
  }

  const saveChangesToProduct = async () => {
    setModified(true)
    const check=handleValdiation()
    if(!check){
      return
    }
    if(action === "edit") {
      let updatedPayload = {...payloadForProductEdit};
      let id = productDetails['id'];

      updatedPayload.payload = {...payloadForProductEdit.payload}
      updatedPayload.payload['id'] = id
      //send images that don't have image_id as payload.
      if (images.length !== 0)  updatedPayload.payload['images'] = images.filter( image => !image.image_id);
      callBackFunctions.saveChanges(updatedPayload);
      handleConfirmDialog();
    } 

    if ( action === "add" ) {
      getPurchaseMerchendiseCreateProduct();
    }
  }

  const availableOptions = () => {
    let options = [];
    switch (category?.toLowerCase()) {
      case "clothes":
        options = [
          {
            value: "S",
            label: "S"
          },
          {
            value: "M",
            label: "M"
          },
          {
            value: "L",
            label: "L"
          },
          {
            value: "XL",
            label: "XL"
          },
          {
            value: "XXL",
            label: "XXL"
          }
        ]
        break;
      case "electronics":
        options = [
          {
            value: "Laptop",
            label: "Laptop"
          },
          {
            value: "HeadSet",
            label: "HeadSet"
          },
          {
            value: "Dongle",
            label: "Dongle"
          },
          {
            value: "Charger",
            label: "Charger"
          }
        ]
        break;
      case "coolers & bags":
        options = [
          {
            value: "Mixen Lunch Bag",
            label: "Mixen Lunch Bag"
          },
          {
            value: "Water Bottle",
            label: "Water Bottle"
          },
          {
            value: "Hand Bag",
            label: "Hand Bag"
          }
        ]
        break;
        case "Others":
          options = [{
            value : 'Others',
            label : 'Others'
          }];
          break;
      default:
        options = [{
          value : 'Others',
          label : 'Others'
        }];
    }
    return (
      <>
        <InputLabel id="available-sizes" size="small">
          Available Types
        </InputLabel>
        <Select
          variant="outlined"
          size="small"
          labelId="available-types"
          id="available-sizes-modal"
          error={modified && !availableType ? true : ""}
          label="availabletypes"
          value={availableType}
          onChange={(e) => {
            handleChange(e.target.value, "type");
          }}
        >
          {options?.map((item) => {
            return (
              <MenuItem value={item?.value}>
                {item?.label}
              </MenuItem>
            )
          })}
        </Select>
        <div style={{ color: "red" }}>
          {modified && !availableType && (
            <FormHelperText style={{ color: "red" }}>{'Please select type'}</FormHelperText>
          )}
          </div>
      </>
    )
  }
  return (
    <div>
      <Dialog
        maxWidth="sm"
        fullWidth="false"
        sx={{ zIndex: 1000 }}
        open={openDialog}
        onClose={handleClose}
      >
        <DialogTitle sx={{ m: 0, p: 3, width: '600px', textAlign: 'center', color: 'green' }}> { action === "edit" ? 'Edit' : 'Add New'} Product</DialogTitle>
          
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 24,
              top: 24,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>

        <Divider />

        <DialogContent style={{ height: '433px', width: '600px' }}>

          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

          <div className='w-full'>
            {/* PRODUCT NAME */}
            <FormControl sx={{ m: 1, minWidth: "45%", border: "none" }}>
              <TextField
                size="small"
                label="Product Name"
                variant="outlined"
                required
                  error={modified && !currentProduct?.name ? true : ""}
                value={currentProduct?.name}
                onChange={(e) => {
                  handleChange(e.target.value, "name");
                }}
              />
              <div style={{ color: "red" }}>
              {modified && !currentProduct?.name && (
                <FormHelperText style={{ color: "red" }}>{'Please enter product name'}</FormHelperText>
              )}
            </div>
            </FormControl>
            
            {/* CATEGORIES */}
            <FormControl sx={{ m: 1, minWidth: "45%", border: "none" }}>
              <InputLabel id="categories" required size="small" htmlFor='categories'>
                Categories
              </InputLabel>
              <Select
                variant="outlined"
                size="small"
                labelId="categories"
                id="categories"
                label="categories"
                value={category}
                error={modified && !currentProduct?.category_id ? true : ""}
                onChange={(e) => {
                  handleChange(e.target.value, "category");
                }}
              >
                {categoriesList?.map((categoryItem) => { 
                  return (
                    // categoryItem?.name?.toLowerCase() === 'clothes' &&
                    <MenuItem id={categoryItem?.id} value={categoryItem?.name}>
                      {categoryItem?.name}
                    </MenuItem>
                  )
                })
                }
              </Select>
              <div style={{ color: "red" }}>
              {modified && !currentProduct?.category_id && (
                <FormHelperText style={{ color: "red" }}>{'Please select product category'}</FormHelperText>
              )}
            </div>
            </FormControl>
          </div>

          <div>
            {/* PRODUCT PRICE */}
            <FormControl sx={{ m: 1, minWidth: "45%", border: "none" }}>
              <TextField
                type='number'
                InputProps ={{
                  startAdornment: "$"
                }}
                size="small"
                label="Price"
                variant="outlined"
                required
                error={modified && (!currentProduct?.price || currentProduct?.price <= 0) ? true : ""}
                value={currentProduct?.price}
                onChange={(e) => {
                  handlePriceChange(e.target.value);
                }}
                
              />
              <div style={{ color: "red" }}>
              {modified && (!currentProduct?.price || currentProduct?.price <= 0) && (
                <FormHelperText style={{ color: "red" }}>{'Please enter price'}</FormHelperText>
              )}
            </div>
            </FormControl>

            {/* TYPES */}
            <FormControl sx={{ m: 1, minWidth: "45%", border: "none" }}>
              {availableOptions()}
            </FormControl>

          </div>

          <div>
            {/* DESCRIPTION */}
            <FormControl sx={{ m: 1, minWidth: "45%", border: "none" }}>
              <TextField
                size="small"
                label="Description"
                variant="outlined"
                required
                error={modified && !currentProduct?.description ? true : ""}
                value={currentProduct?.description}
                onChange={(e) => {
                  handleChange(e.target.value, "description");
                }}
              />
                <div style={{ color: "red" }}>
                {modified && !currentProduct?.description && (
                <FormHelperText style={{ color: "red" }}>{'Please enter description'}</FormHelperText>
              )}</div>
            </FormControl>

            {/* COLORS */}
            <FormControl sx={{ m: 1, minWidth: "45%", border: "none" }}>
              <InputLabel id="available-colors" size="small">Available Colors</InputLabel>
              <Select
                labelId="available-colors"
                id="available-colors-modal"
                multiple
                size='small'
                label="Available Colors"
                error={modified && availableColor?.length===0 ? true : ""}
                value={availableColor}
                onChange={(e) => handleChange(e.target.value, "color")}
              >
                {names.map((name) => (
                  <MenuItem
                    key={name}
                    value={name}
                  >
                    {name}
                  </MenuItem>
                ))}
              </Select>
              <div style={{ color: "red" }}>
                {modified && availableColor?.length===0 && (
                <FormHelperText style={{ color: "red" }}>{'Please select color'}</FormHelperText>
              )}</div>
            </FormControl>
          </div>
          
          {/* IN STOCK */}
          <div>
            <FormControl sx={{ m: 1, minWidth: "95%", display: 'flex', alignItems: 'center' }}>
              <FormControlLabel style={{ backgroundColor: 'green !important' }}
                sx={{ pl: 2, flexGrow: 1 }}
                control={
                  <Switch
                    checked={isInStock}
                    onChange={(e) => handleChange(e.target.checked, "inStock")}
                    name="active"
                    label="Active"
                  />
                }
                label="In Stock"
              />
            </FormControl>
          </div>

          {/* IMAGES */}
          <div>
            <ImageUploader 
              showUploadButton={images?.length === 0} 
              previouslyUploadedImages = {images} 
              sendImageDataToParent={setImages}
            />
            <div>
                {modified && images?.length === 0 && (
                <FormHelperText style={{ color: "red",textAlign:'center',paddingTop:'0.5rem' }}>{'Please upload product image'}</FormHelperText>
              )}</div>
          </div>
        </DialogContent>
        <Divider />

        {/* DIALOG ACTIONS */}
        <DialogActions style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Button 
            variant='contained' 
            color='success'
            style={{ background: 'green' }} 
            onClick={() => saveChangesToProduct()}
            // disabled={updateButtonDisabled}
          >
            {action === "edit" ? 'Update' :'Add'}
          </Button>
          <Button variant="contained" color="error" style={{ backgroundColor: '#d32f2f' }}
            onClick={handleClose}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>

  );
}
